import { beeyTheme, createDynamicGreyTheme } from 'ant-config';
import { useCallback, useMemo } from 'react';
import { getSubdomainConfig, SUBDOMAIN_CONFIG } from 'libs/subdomain';
export const useAppTheme = () => {
    const config = useMemo(() => getSubdomainConfig(), []);
    const firstConfig = SUBDOMAIN_CONFIG[Object.keys(SUBDOMAIN_CONFIG)[0]];
    const changeFavicon = useCallback((fileName) => {
        const faviconLink = document.querySelector('link[type="image/x-icon"]');
        faviconLink === null || faviconLink === void 0 ? void 0 : faviconLink.remove();
        const iconLinks = document.querySelectorAll('link.favicon');
        Array.from(iconLinks).forEach((link) => {
            const url = new URL(link.href);
            // eslint-disable-next-line no-param-reassign
            link.href = url.pathname.replace('beey', fileName);
        });
    }, []);
    const changeTheme = useCallback((onSetTheme, isGrey) => {
        const grey = (config === null || config === void 0 ? void 0 : config.isGrey) === true || isGrey === true;
        const activeConfig = grey ? (config !== null && config !== void 0 ? config : firstConfig) : undefined;
        const theme = activeConfig
            ? createDynamicGreyTheme(activeConfig.colors.headerBgColor, activeConfig.colors.headerColor)
            : beeyTheme;
        onSetTheme(theme);
        document.documentElement.setAttribute('data-theme', grey ? 'grey' : '');
        if (activeConfig) {
            changeFavicon(activeConfig.logoName);
        }
    }, [config, firstConfig]);
    return {
        changeTheme,
    };
};
